/**
 * Public Providers Wrapper
 * =========================
 * Lightweight provider tree for public routes (landing, pricing, checkout,
 * portal auth, etc.). Only includes the contexts that public pages need:
 *
 *   - PortalProvider  (portal account state for signup/login modals)
 *   - AuthProvider    (app auth state — lightweight, no API calls until used)
 *   - DemoTrialProvider (demo countdown — only fetches if a token exists)
 *   - ToastProvider   (toast notifications)
 *
 * All app-only providers (Subscription, Organization, Currency, Timezone,
 * ReportTemplate, DataCache, Search, Confirm, ClinicalParameters, Permission)
 * are mounted by AppProviders inside MainLayout so they never load on public
 * pages.
 */
import React from 'react';
import { AuthProvider } from '../context/AuthContext';
import { PortalProvider } from '../context/PortalContext';
import { DemoTrialProvider } from '../context/DemoTrialContext';
import { CountryCurrencyProvider } from '../context/CountryCurrencyContext';
import { ToastProvider } from './common/Toast';

const PublicProviders = ({ children }) => {
  return (
    <PortalProvider>
      <AuthProvider>
        <DemoTrialProvider>
          <CountryCurrencyProvider>
            <ToastProvider>
              {children}
            </ToastProvider>
          </CountryCurrencyProvider>
        </DemoTrialProvider>
      </AuthProvider>
    </PortalProvider>
  );
};

export default PublicProviders;
